export const orgranizationDepartment = [
  { value: "Emergency Department (ED)", label: "Emergency Department (ED)" },
  {
    value: "ICU (MICU, SICU, CVICU, TICU)",
    label: "ICU (MICU, SICU, CVICU, TICU)",
  },
  {
    value: "Step-Down / Progressive Care (PCU/IMCU)",
    label: "Step-Down / Progressive Care (PCU/IMCU)",
  },
  {
    value: "Operating Room (OR),  PACU, Pre-op",
    label: "Operating Room (OR),  PACU, Pre-op",
  },
  { value: "Cath Lab", label: "Cath Lab" },
  { value: "Medical-Surgical Units", label: "Medical-Surgical Units" },
  { value: "Telemetry Units", label: "Telemetry Units" },
  { value: "Float Pool", label: "Float Pool" },
  {
    value: "Pediatric Emergency Department",
    label: "Pediatric Emergency Department",
  },
  { value: "PICU / NICU", label: "PICU / NICU" },
  { value: "Pediatric OR / PACU", label: "Pediatric OR / PACU" },
  {
    value: "Pediatric Med-Surg / General Pediatric Units",
    label: "Pediatric Med-Surg / General Pediatric Units",
  },
  { value: "Outpatient Surgery Centers", label: "Outpatient Surgery Centers" },
  { value: "Imaging / Radiology", label: "Imaging / Radiology" },
  {
    value: "Interventional Radiology (IR)",
    label: "Interventional Radiology (IR)",
  },
  {
    value: "Cardiology Clinics / Stress Test Labs",
    label: "Cardiology Clinics / Stress Test Labs",
  },
  { value: "Dialysis Units", label: "Dialysis Units" },
  {
    value: "Primary Care / Specialty Clinics",
    label: "Primary Care / Specialty Clinics",
  },
  {
    value: "Pediatric Ambulatory Surgery",
    label: "Pediatric Ambulatory Surgery",
  },
  {
    value: "Pediatric Imaging (MRI, CT, Sedation)",
    label: "Pediatric Imaging (MRI, CT, Sedation)",
  },
  {
    value: "Specialty Clinics (Cardiology, Pulmonology, Neurology)",
    label: "Specialty Clinics (Cardiology, Pulmonology, Neurology)",
  },
  {
    value: "School-Based or Community Clinics",
    label: "School-Based or Community Clinics",
  },
  { value: "Respiratory Therapy", label: "Respiratory Therapy" },
  { value: "Pharmacy", label: "Pharmacy" },
  { value: "Laboratory Services", label: "Laboratory Services" },
  { value: "Risk Management / Quality", label: "Risk Management / Quality" },
  { value: "Other", label: "Other" },
];

export const orgranizationRole = [
  { value: "Registered Nurses (RNs)", label: "Registered Nurses (RNs)" },
  {
    value: "Advanced Practice Nurses (NPs, CNSs, CRNAs)",
    label: "Advanced Practice Nurses (NPs, CNSs, CRNAs)",
  },
  {
    value: "CNA/LNA/ Nursing assistants",
    label: "CNA/LNA/ Nursing assistants",
  },
  { value: "Physicians (MD, DO)", label: "Physicians (MD, DO)" },
  { value: "Paramedics/EMT/Tech’s", label: "Paramedics/EMT/Tech’s" },
  {
    value: "Respiratory Therapists (RTs)",
    label: "Respiratory Therapists (RTs)",
  },
  {
    value: "Radiology/Imaging Technologists",
    label: "Radiology/Imaging Technologists",
  },
  {
    value: "Pharmacists/Pharmacy Technicians",
    label: "Pharmacists/Pharmacy Technicians",
  },
  { value: "Laboratory Technologists", label: "Laboratory Technologists" },
  {
    value: "Physical Therapists / Occupational Therapists",
    label: "Physical Therapists / Occupational Therapists",
  },
  {
    value: "Speech-Language Pathologists",
    label: "Speech-Language Pathologists",
  },
  {
    value: "Simulation/Education Specialists",
    label: "Simulation/Education Specialists",
  },
  {
    value: "Quality & Risk Management Staff",
    label: "Quality & Risk Management Staff",
  },
  { value: "Informatics/IT Support", label: "Informatics/IT Support" },
  {
    value: "Unit Clerks / Health Unit Coordinators",
    label: "Unit Clerks / Health Unit Coordinators",
  },
  { value: "Nurse Leaders", label: "Nurse Leaders" },
  { value: "Medical Directors", label: "Medical Directors" },
  { value: "Patient Safety Officers", label: "Patient Safety Officers" },
  { value: "Hospital Administrators", label: "Hospital Administrators" },
  { value: "Medical assistants", label: "Medical assistants" },
  { value: "Transport", label: "Transport" },
];
